import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'antd';
import cs from 'classnames';

import SectionTitle from 'components/SectionTitle/SectionTitle';

import { GTMEventLogger } from 'utils/GTMEventLogger';

import { GTMEvents } from 'constants/enums';
import { EMPLOYERS } from 'constants/path';
import { PRELOADER_ID } from 'constants/preloader';

import { ReactComponent as ArrowRight } from 'assets/icons/arrowRight.svg';

import styles from './SplitScreen.module.scss';

const SplitScreen = () => {
  const navigate = useNavigate();
  const [isPreloaderPresent, setIsPreloaderPresent] = useState(false);

  useEffect(() => {
    const preloader = document.getElementById(PRELOADER_ID);

    setIsPreloaderPresent(Boolean(preloader));

    // Create observer to watch for preloader removal
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.removedNodes.length) {
          const wasPreloaderRemoved = Array.from(mutation.removedNodes).some(
            (node) => (node as Element).id === PRELOADER_ID
          );

          if (wasPreloaderRemoved) {
            setIsPreloaderPresent(false);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, []);

  const handleEmployerNavigation = () => {
    GTMEventLogger(GTMEvents.HomeLookingForWorkersClick);
    navigate(`${EMPLOYERS}#form`, { replace: true });
  };

  const handleWorkerNavigation = () => {
    GTMEventLogger(GTMEvents.HomeLookingForWorkClick);
    window.open('https://join.joblio.co', '_blank');
  };

  return (
    <div className={styles.splitScreen}>
      <div className={styles.leftSide}>
        <div
          className={cs(styles.leftContent, {
            [styles.animate]: !isPreloaderPresent
          })}
        >
          <SectionTitle
            highlightText="LOOKING FOR"
            mainText="EMPLOYEES?"
            color="yellow"
          />
          <Button
            className={styles.btn}
            type="primary"
            icon={<ArrowRight />}
            iconPosition="end"
            onClick={handleEmployerNavigation}
          >
            Hire
          </Button>
        </div>
      </div>
      <div className={styles.rightSide}>
        <div
          className={cs(styles.rightContent, {
            [styles.animate]: !isPreloaderPresent
          })}
        >
          <SectionTitle
            highlightText="LOOKING FOR"
            mainText="WORK?"
            color="white"
            textAlign="right"
          />

          <Button
            className={cs(styles.btn, styles.btnWhite)}
            type="default"
            icon={<ArrowRight />}
            iconPosition="end"
            onClick={handleWorkerNavigation}
          >
            Get work
          </Button>
        </div>
        <div
          className={cs(styles.rightOverlay, {
            [styles.animate]: !isPreloaderPresent
          })}
        />
      </div>
    </div>
  );
};

export default SplitScreen;
